import {reamazeLib} from 'services/AsyncJSLoader';
import {TranslateSvc} from './services/TranslateSvc';
import {Utils} from './underscore-extensions';

export class Reamaze {
    reamazePromise: Promise<any>;

    constructor() {
        //this.reamazePromise = options.isProduction ? this.initialize() : () => ({then: angular.noop});
        this.reamazePromise = this.initialize();
    }

    initialize() {
        window._support                 = window._support || {'ui': {widget: {}}, 'user': {}};
        window._support['account']      = 'Animatron';
        window._support['ui']['widget'] = {
            position: {
                right: '-48px',
                bottom: '150px'
            },
            label: 'Ask Us Anything',
            size: 32,
            icon: 'chat',
            color: 'rgba(44,150,221,.6)'
        };
        return new Promise(resolve =>
            setTimeout(() =>
                    options.handHeld ? angular.noop : resolve(reamazeLib()),
                3000));
    }

    setUser(user: anm.User) {
        const reamazeUser: any = window._support['user'];
        const differentUser    = user.userId !== reamazeUser.id || user.auth.reamaze !== reamazeUser.authkey;
        const strTest = options.isProduction ? '' : '-test';

        if (differentUser && user.auth && user.auth.reamaze) {
            this.reamazePromise.then(r => {
                const signUpDate = new Date(user.created);
                const userData   = {
                    id: user.userId,
                    email: user.email,
                    name: user.displayName,
                    authkey: user.auth.reamaze,
                    avatar: user.avatar,
                    data: {
                        Subscriptions: undefined as string | undefined,
                        SignedUp: undefined as Date | undefined,
                        Stripe: undefined as string | undefined,
                        Occupation: undefined as string | undefined,
                        Industry: user.meta.industry,
                        Goals: user.meta.goals && user.meta.goals.join(', '),
                        Profile: `${location.origin}/${user.meta.product.toLowerCase()}/users/${user.username}`,
                        Admin: `https://webadmin.animatron${strTest}.com/admin/user.html?userId=${user.userId}`,
                        Product: user.meta.product,
                        OS: window.navigator.platform,
                        Browser: Utils.getBrowserName()
                    }
                };

                userData.data.Subscriptions = this.makeSubscriptionInfo(user);

                if (user.meta.occupation) userData.data.Occupation = user.meta.occupation;
                if (!isNaN(signUpDate.getTime())) userData.data.SignedUp = signUpDate;
                if (user.isStripe()) {
                    userData.data.Stripe = 'https://dashboard.stripe.com/customers/' + user.userId;
                }
                r._user = window._support['user'] = userData;
                this.reload();
            });
        }
    }

    setAnonymous() {
        this.reamazePromise.then(r => {
            r._user = window._support['user'] = {};
            this.reload();
        });
    }

    reload() {
        this.reamazePromise.then(r => {
            try {
                _.extend(window._support['ui']['widget'], {
                    label: angular.element(document).injector().get<TranslateSvc>('TranslateSvc').get('ask.us')
                });
            } catch (e) {
                console.error(e);
            }
            if (r._initialized) {
                r.reload();
                r.closePopup();
            }
        });
    }

    private makeSubscriptionInfo(user: anm.User) {
        const {wave, studio} = user.subscriptionDetails;
        const filter         = angular.element(document)
            .injector()
            .get<ng.IFilterService>('$filter')('date');

        const getInfo = (subscription: anm.SubscriptionDetails) => {
            const period = ['WaveFree', 'Free'].includes(subscription.name) ? '' : `/${subscription.billingPeriod}`;
            const plan   = subscription.name + period;

            if (subscription.expirationDate) {
                const date      = filter(subscription.expirationDate * 1000, 'MM/dd/yyyy');
                const shortData = `expires on ${date}`;
                return `[${plan}, ${shortData}]`;
            } else {
                return plan;
            }
        };

        return `${getInfo(studio)}, ${getInfo(wave)}`;
    }
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/reamaze.ts